/**
 * Web Vitals OTel Metrics
 *
 * Records Core Web Vitals (INP, LCP, CLS) as OTel histogram metrics.
 * Lives in core/ so both app/ and dashboard/ config files can import it.
 *
 * Falls back to a no-op when telemetry is not initialised (e.g. tests).
 */

import type { Histogram } from "@opentelemetry/api";
import { metrics } from "@opentelemetry/api";

const METER_NAME = "superblocks-ui";

function getMeter() {
  return metrics.getMeter(METER_NAME);
}

let inpHistogram: Histogram | undefined;
let lcpHistogram: Histogram | undefined;
let clsHistogram: Histogram | undefined;

function getINPHistogram(): Histogram {
  if (!inpHistogram) {
    inpHistogram = getMeter().createHistogram("ui_web_vital_inp_ms", {
      description:
        "Interaction to Next Paint (INP) — input latency in milliseconds",
      unit: "ms",
    });
  }
  return inpHistogram;
}

function getLCPHistogram(): Histogram {
  if (!lcpHistogram) {
    lcpHistogram = getMeter().createHistogram("ui_web_vital_lcp_ms", {
      description:
        "Largest Contentful Paint (LCP) — render time in milliseconds",
      unit: "ms",
    });
  }
  return lcpHistogram;
}

function getCLSHistogram(): Histogram {
  if (!clsHistogram) {
    clsHistogram = getMeter().createHistogram("ui_web_vital_cls", {
      description:
        "Cumulative Layout Shift (CLS) — unitless layout shift score",
    });
  }
  return clsHistogram;
}

export function recordINP(
  value: number,
  attributes?: Record<string, string>,
): void {
  getINPHistogram().record(value, attributes);
}

export function recordLCP(
  value: number,
  attributes?: Record<string, string>,
): void {
  getLCPHistogram().record(value, attributes);
}

export function recordCLS(
  value: number,
  attributes?: Record<string, string>,
): void {
  getCLSHistogram().record(value, attributes);
}

/** Reset lazy singletons (for tests). */
export function resetWebVitalsMetrics(): void {
  inpHistogram = undefined;
  lcpHistogram = undefined;
  clsHistogram = undefined;
}
